import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { dividerStyles } from './Divider.styles';
import { dividerTheme } from './Divider.stylex';
import { Base } from '../Base';
import { useStyles } from '../../hooks/useStyles';
// https://github.com/material-components/material-web/blob/main/divider/internal/divider.ts
export const Divider = forwardRef(function Divider(props, forwardedRef) {
    const { styles, sx, orientation = 'horizontal', inset, insetStart, insetEnd, children, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'Divider',
        styles: [dividerStyles, styles],
    });
    const renderLine = () => (_jsx("div", { ...getStyles('line', `line$${orientation}`, (inset || insetStart) && `line$${orientation}$insetStart`, (inset || insetEnd) && `line$${orientation}$insetEnd`) }));
    return (_jsx(Base, { ...other, sx: [
            dividerTheme,
            globalStyles,
            combineStyles('host', `host$${orientation}`),
            sx,
        ], ref: forwardedRef, children: children ? (_jsxs(_Fragment, { children: [renderLine(), _jsx("div", { ...getStyles(`textContainer$${orientation}`), children: _jsx("div", { ...getStyles('text'), children: children }) }), renderLine()] })) : (renderLine()) }));
});
